<template>
  <el-card>
    <el-form ref="searchForm" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" clearable placeholder="项目名称">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="dateArr" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">
      <el-button type="primary" icon="el-icon-plus" @click="onAdd">新增</el-button>
    </div>
    <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
      <el-table-column label="项目名称" prop="projectName" show-overflow-tooltip></el-table-column>
      <el-table-column label="费用月份" prop="actualIndirectYm" show-overflow-tooltip></el-table-column>
      <el-table-column label="费用金额（元）" prop="actualIndirectAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="填报日期" prop="actualIndirectDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetails(row)">查看</el-button>
          <el-button type="text" @click="onEdit(row)">编辑</el-button>
          <el-button type="text" @click="onDelete(row.indirectId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
      @size-change="loadData"></global-pagination>

    <el-dialog :visible.sync="dialogVisible" title="间接费" width="800px">
      <el-form class="global-form2" :model="formData" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="项目名称" prop="projectId">
          <el-select v-model="formData.projectId" :disabled="!!formData.indirectId" placeholder="请选择所属项目">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="actualIndirectYm" label="费用月份">
          <el-date-picker v-model="formData.actualIndirectYm" :disabled="!!formData.indirectId" value-format="yyyy-MM"
            type="month" placeholder="请选择费用月份"></el-date-picker>
        </el-form-item>
        <el-form-item class="plan" prop="indirectDetailList" label="费用明细">
          <el-table :data="formData.indirectDetailList" border>
            <el-table-column prop="indirectTypeName" label="间接费类型">
              <template v-slot="{ row, $index }">
                <el-form-item v-if="row.edit" :show-message="false" inline-message
                  :prop="`indirectDetailList.${$index}.indirectType`"
                  :rules="[{ required: true, message: '请选择间接费类型' }]">
                  <el-select v-model="row.indirectType" placeholder="请选择间接费类型"
                    @change="val => indirectTypeChange(val, row)">
                    <el-option v-for="(item, index) in indirectTypeList" :key="index" :label="item.dicValue"
                      :value="item.dicCode"></el-option>
                  </el-select>
                </el-form-item>
                <span v-else>{{ row.indirectTypeName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="indirectAmount" label="金额（元）">
              <template v-slot="{ row, $index }">
                <el-form-item v-if="row.edit" inline-message :prop="`indirectDetailList.${$index}.indirectAmount`"
                  :rules="[{ required: true, message: '请输入金额' }, { validator: twoDecimal }]">
                  <el-input v-model="row.indirectAmount" placeholder="请输入金额"></el-input>
                </el-form-item>
                <span v-else>{{ row.indirectAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bak" label="备注">
              <template v-slot="{ row, $index }">
                <el-form-item v-if="row.edit">
                  <el-input v-model="row.bak" placeholder="请输入备注"></el-input>
                </el-form-item>
                <span v-else>{{ row.bak }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="{ row, $index }">
                <template v-if="row.edit">
                  <el-button type="text" @click="onSave(row, $index)">保存</el-button>
                  <el-button type="text" @click="onCancel(row, $index)">取消</el-button>
                </template>
                <template v-else>
                  <el-button type="text" v-if="!row.disabled" @click="onEditRow(row)">编辑</el-button>
                  <el-button type="text" @click="onDeleteRow($index)">删除</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-button icon="el-icon-plus" type="text" @click="onAddRow">添加费用明细</el-button>
        </el-form-item>
        <el-form-item prop="contractAmount" label="附件">
          <!-- <el-input disabled v-model="formData.contractAmount" placeholder="请输入合同总额"></el-input> 元 -->
          <file-upload v-model="formData.fileList"
            accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" title="间接费" width="800px">
      <el-form class="global-form2" label-width="120px">
        <el-form-item label="项目名称" prop="projectId">
          {{ formData.projectName }}
        </el-form-item>
        <el-form-item prop="actualIndirectYm" label="费用月份">
          {{ formData.actualIndirectYm }}
        </el-form-item>
        <el-form-item prop="endDate" label="费用明细">
          <el-table :data="formData.indirectDetailList" border>
            <el-table-column prop="indirectTypeName" label="间接费类型"></el-table-column>
            <el-table-column prop="indirectAmount" label="金额（元）"></el-table-column>
            <el-table-column prop="bak" label="备注"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item prop="fileList" label="附件">
          <file-upload readonly v-model="formData.fileList"
            accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { deepClone } from '@/utils/util'
import { twoDecimal } from '@/utils/validate'
import FileUpload from '@/components/FileUpload.vue'
export default {
  name: "IndirectCost",
  components: {
    FileUpload
  },
  data() {
    return {
      dateArr: [],
      twoDecimal,
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        projectId: '',
        startTime: '',
        endTime: ''
      },
      formData: {
        projectId: '', // 项目ID
        actualIndirectYm: '', // 费用月份
        indirectDetailList: [], // 间接费明细列表
        // indirectType: '', // 间接费类型(字典类型indirectType)
        // indirectAmount: '', // 间接费金额
        // bak: '', // 备注说明
        fileList: []
      },
      indirectTypeList: [],
      rules: {
        projectId: [
          { required: true, message: '请选择项目名称' }
        ],
        actualIndirectYm: [
          { required: true, message: '请选择费用月份' }
        ],
        indirectDetailList: [
          { required: true, type: 'array', message: '请添加间接费明细' }
        ]
      },
      dialogVisible: false,
      dialogVisible2: false
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {},
  created() {
    this._tempRow = null
    this.loadData()
    this.loadDict()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.operate.selectIndirectByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm,
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    loadDetails(indirectId) {
      return this.$axios.get(this.$apis.operate.selectIndirectByIndirectId, {
        indirectId
      }).then(res => {
        res.indirectDetailList.forEach(item => {
          item.edit = false
        })
        this.formData = res
      })
    },
    dateChange(date) {
      if (date) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'indirectType' }).then(res => {
        this.indirectTypeList = res.indirectType || []
      })
    },
    indirectTypeChange(val, row) {
      const data = this.indirectTypeList.find(item => item.dicCode === val)
      row.indirectTypeName = data.dicValue
    },
    onAdd() {
      this.formData = {
        projectId: '', // 项目ID
        actualIndirectYm: '', // 费用月份
        indirectDetailList: [], // 间接费明细列表
        // indirectType: '', // 间接费类型(字典类型indirectType)
        // indirectAmount: '', // 间接费金额
        fileList: []
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    onAddRow() {
      this.formData.indirectDetailList.push({
        indirectType: '', // 间接费类型(字典类型indirectType)
        indirectTypeName: '',
        indirectAmount: '', // 间接费金额
        bak: '', // 备注说明
        edit: true
      })
    },
    onEdit(row) {
      this.loadDetails(row.indirectId).then(() => {
        this.dialogVisible = true
      })
    },
    onDetails(row) {
      this.loadDetails(row.indirectId).then(() => {
        this.dialogVisible2 = true
      })
    },
    onEditRow(row) {
      this._tempRow = deepClone(row)
      row.edit = true
    },
    onSave(row, index) {
      let errorMsg = ''
      this.$refs.form.validateField([
        `indirectDetailList.${index}.indirectType`,
        `indirectDetailList.${index}.indirectAmount`
      ], error => {
        errorMsg = error
      })
      if (!errorMsg) {
        row.edit = false
        console.log('this....', this.formData)
      }
    },
    onDeleteRow(index) {
      this.formData.indirectDetailList.splice(index, 1)
    },
    onCancel(row, index) {
      if (row.indirectId) {
        this.formData.indirectDetailList.splice(index, 1, this._tempRow)
      } else {
        this.formData.indirectDetailList.splice(index, 1)
      }
    },
    onDelete(indirectId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.operate.deleteIndirect, { indirectId }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    },
    onSubmit() {
      console.log('formData', this.formData)
      this.$refs.form.validate().then(() => {
        let url = this.$apis.operate.insertIndirect
        if (this.formData.indirectId) {
          url = this.$apis.operate.updateIndirect
        }
        const formData = deepClone(this.formData)
        formData.indirectDetailList.forEach(item => {
          delete item.edit
          delete item.indirectTypeName
        })
        this.$axios.post(url, formData).then(() => {
          this.$message.success('提交成功')
          this.dialogVisible = false
          this.onSearch()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.plan {
  ::v-deep {
    .el-form-item {
      margin-bottom: 0;

      .el-input,
      .el-select {
        width: 100% !important;
      }
    }
  }
}
</style>
